/* eslint-disable prefer-spread */
import { useEffect, useState } from "react";

export function useActive(editor, ...args) {
	const [active, toggleActive] = useState(false);

	useEffect(() => {
		const listener = () => {
			toggleActive(editor.isActive.apply(editor, args));
		};

		editor.on("selectionUpdate", listener);
		editor.on("transaction", listener);

		return () => {
			editor.off("selectionUpdate", listener);
			editor.off("transaction", listener);
		};
	}, [editor, args, toggleActive]);

	return active;
}
